// extracted by mini-css-extract-plugin
export default {"blockLoading":"BlockLoading_blockLoading__AE1PN","loader":"BlockLoading_loader__a12zh","rot1":"BlockLoading_rot1__95gxp"};